import type { ExceptionStackFrame } from "@grafana/faro-react";

// Scripts injected by browser extensions throw errors we cannot fix. Safari
// masks their origin as webkit-masked-url://hidden/.
export const browserExtensionUrlPatterns = [
  /^webkit-masked-url:\/\//,
  /^safari-web-extension:\/\//,
  /^safari-extension:\/\//,
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
];

// Only the topmost frame decides: when an extension throws inside a hook it
// patched onto a browser API, our frames below it are just the call chain in.
export function isBrowserExtensionError(frames: ExceptionStackFrame[]) {
  const originFrame = frames.at(0);

  return (
    originFrame != null &&
    browserExtensionUrlPatterns.some((pattern) =>
      pattern.test(originFrame.filename),
    )
  );
}
